import React from "react";
import contextProvider from "../../contextProvider";
import {
  ResponsiveContainer,
  ComposedChart,
  CartesianGrid,
  XAxis,
  Area,
  Line,
  Label,
  // Tooltip,
} from "recharts";

import _ReactOBaseComponent, {
  withDefinedContext,
} from "../../_L0_components/_ReactOBaseComponent";

const context_exposed_methods = ["setActive", "unsetActive"];

class BandwidthOverlapChart extends _ReactOBaseComponent {
  constructor(props) {
    var initState = {
      activeIndex: null,
    };
    super(props, initState);
  }

  setActive(data, index) {
    this.setState(
      {
        activeIndex: index,
      },
      () => {
        if (this.props.onSetActive) {
          this.props.onSetActive(data, index);
        }
      }
    );
  }

  unsetActive() {
    this.setState(
      {
        activeIndex: this.props.default ? this.props.default : null,
      },
      () => {
        if (this.props.onUnsetActive) {
          this.props.onUnsetActive(
            this.props.default && this.props.data
              ? this.props.data[this.props.default]
              : false,
            this.props.default ? this.props.default : false
          );
        }
      }
    );
  }

  calcPercentage(num, max) {
    let perc = (100 * num) / max;
    return Math.round(perc * 100) / 100;
  }

  /////////////////////////
  //	Lifecycle methods
  //

  onComponentDidMount() {
    if (this.props.onControllerReady) {
      this.props.onControllerReady(this.getContext().BandwidthOverlapChart);
    }
  }

  convertClassToHex(string) {
    switch (string) {
      case "text-success":
        return "#28A745";
      case "text-orange":
        return "#fd7e14";
      case "text-danger":
        return "#dc3545";
      default:
        return "";
    }
  }

  onComponentWillUnmount() {}

  onRender() {
    let overlapChartData = [];
    let overlapChartExtraData = [];
    let referenceBw = this.props.data.reference;
    let referenceFrequency = [
      referenceBw.bw_min,
      referenceBw.bw_carrier,
      referenceBw.bw_max,
    ];
    if (referenceBw.beacon_bw_carrier) {
      referenceFrequency.push(
        referenceBw.beacon_bw_min,
        referenceBw.beacon_bw_carrier,
        referenceBw.beacon_bw_max
      );
    }

    let overlappingBw = [...this.props.data.filterdBssid];
    let referenceFrequencyTicks = [...new Set(referenceFrequency)];

    let arrayOfY = [];
    [...[referenceBw], ...overlappingBw].forEach((elem, id) => {
      let rawY = Math.pow(
        10,
        (Math.abs(this.props.data.reference.rssi) - Math.abs(elem.rssi)) / 10
      );
      arrayOfY.push({ bssid_orig: elem.bssid_orig, rawY: rawY });
    });

    let chartYvalues = {};
    let maxY;
    arrayOfY
      .sort(function (a, b) {
        return b.rawY - a.rawY;
      })
      .forEach((elem, id) => {
        if (id == 0) {
          chartYvalues[elem.bssid_orig] = 100;
          maxY = elem.rawY;
        } else {
          chartYvalues[elem.bssid_orig] = this.calcPercentage(elem.rawY, maxY);
        }
      });

    [...[referenceBw], ...overlappingBw].forEach((_C_bw, _C_idx) => {
      overlapChartExtraData.push(_C_bw);
      let o1 = { freq: _C_bw.bw_min };
      let o2 = { freq: _C_bw.bw_min };
      let o3 = { freq: _C_bw.bw_max };
      let o4 = { freq: _C_bw.bw_max };
      let o5 = { freq: _C_bw.bw_carrier };
      let o6 = { freq: _C_bw.bw_carrier };

      o1[_C_bw.is_reference ? "ref" : _C_bw.bssid_orig] = 0;
      o2[_C_bw.is_reference ? "ref" : _C_bw.bssid_orig] =
        chartYvalues[_C_bw.bssid_orig] < 3 ? 3 : chartYvalues[_C_bw.bssid_orig];
      o3[_C_bw.is_reference ? "ref" : _C_bw.bssid_orig] =
        chartYvalues[_C_bw.bssid_orig] < 3 ? 3 : chartYvalues[_C_bw.bssid_orig];
      o4[_C_bw.is_reference ? "ref" : _C_bw.bssid_orig] = 0;

      o5["center_" + (_C_bw.is_reference ? "ref" : _C_bw.bssid_orig)] = 0;
      o6["center_" + (_C_bw.is_reference ? "ref" : _C_bw.bssid_orig)] =
        chartYvalues[_C_bw.bssid_orig] < 3 ? 3 : chartYvalues[_C_bw.bssid_orig];
      overlapChartData.push(o1, o2, o3, o4, o5, o6);
    });

    if (referenceBw.beacon_bw_carrier) {
      let o7 = { freq: referenceBw.beacon_bw_min, beacon: 0 };
      let o8 = { freq: referenceBw.beacon_bw_max, beacon: 0 };
      let o9 = { freq: referenceBw.beacon_bw_carrier, beacon: 0 };
      overlapChartData.push(o7, o8, o9);
    }

    const rangeColor = this.getAppContext().getRangeColor(
      "rssi",
      this.props.data.reference.rssi,
      true
    );

    return (
      <div>
        <ResponsiveContainer
          aspect={this.props.aspectRatio || 2.0}
          maxHeight={this.props.maxHeight || "auto"}
        >
          <ComposedChart
            data={overlapChartData}
            margin={{ top: 5, right: 0, bottom: 10, left: 0 }}
          >
            <CartesianGrid horizontal={false} vertical={false} />
            {/* <YAxis
              // tickSize={10}
              scale="linear"
              allowDataOverflow={false}
              domain={[0, 100]}
              type="number"
            /> */}
            <XAxis
              ticks={referenceFrequencyTicks}
              tick={(props) => {
                const { index, x, y, payload, fill } = props;
                return (
                  <g transform={`translate(${x},${y})`}>
                    <text
                      x={0}
                      y={0}
                      dy={16}
                      textAnchor="end"
                      fontSize={12}
                      strokeWidth={index == 1 ? 1 : 0}
                      stroke={index == 1 ? "#337ab7" : fill}
                      transform="rotate(-30)"
                    >
                      {payload.value}
                    </text>
                  </g>
                );
              }}
              interval={0}
              type="number"
              minTickGap={1}
              domain={[referenceFrequencyTicks[0] - 12, referenceFrequencyTicks[2] + 12]}
              dataKey="freq"
              scale="linear"
            >
              <Label
                fontSize={13}
                fill={this.getAppContext().colors.gray600}
                value="MHz"
                position="insideBottomRight"
              />
            </XAxis>

            {overlapChartExtraData.map((_C_bw, _C_idx) => {
              // Overlap - red?
              return (
                <Area
                  key={_C_idx}
                  type="linear"
                  dataKey={_C_bw.bssid_orig}
                  stroke={this.getAppContext().colors.gray500}
                  // stroke="#721c24"
                  // fill="#f5c6cb"
                  strokeWidth={1}
                  // strokeOpacity={1}
                  fillOpacity={0}
                  isAnimationActive={false}
                  dot={false}
                  activeDot={false}
                />
              );
            })}

            {/* REF */}
            <Area
              type="linear"
              dataKey="ref"
              stroke="#337ab7"
              fill="#337ab7"
              strokeWidth={
                this.props.bssidActive && referenceBw.bssid_orig == this.props.bssidActive
                  ? 4
                  : 3
              }
              strokeOpacity={1}
              fillOpacity={0.5}
              isAnimationActive={false}
              dot={false}
              // activeDot={false}
            />

            {this.props.bssidActive
              ? overlapChartExtraData.map((_C_bw, _C_idx2) => {
                  // Overlap - red?
                  return (
                    _C_bw.bssid_orig == this.props.bssidActive && (
                      <Area
                        key={"active_" + _C_idx2}
                        type="linear"
                        dataKey={_C_bw.bssid_orig}
                        stroke={this.getAppContext().colors.gray500}
                        // stroke="#721c24"
                        fill={this.getAppContext().colors.gray500}
                        strokeWidth={4}
                        // strokeOpacity={1}
                        fillOpacity={0}
                        isAnimationActive={false}
                        dot={false}
                        activeDot={false}
                      />
                    )
                  );
                })
              : null}

            {/* Beacon */}
            {referenceBw.beacon_bw_carrier && (
              <Line
                type="monotone"
                dataKey="beacon"
                stroke={this.convertClassToHex(rangeColor)}
                strokeWidth={3}
                isAnimationActive={false}
                dot={false}
                activeDot={false}
                // strokeDasharray="4"
              />
            )}
          </ComposedChart>
        </ResponsiveContainer>

        {this.props.showBeacon && referenceBw.beacon_bw_carrier && (
          <div className="pt-1">
            <span className={`icon-dot-01 beacon-legend ${rangeColor}`} />
            <span className="sub-title text-muted" style={{ verticalAlign: "middle" }}>
              Beacon channel
            </span>
          </div>
        )}
      </div>
    );
  }
}

export default contextProvider(
  withDefinedContext(
    BandwidthOverlapChart,
    "BandwidthOverlapChart",
    context_exposed_methods
  ),
  {
    define: null,
  }
);
